import { useCallback } from 'react';

import { showModal } from 'modal.react.js';
import { useHistory } from 'react-router-dom';

import { ACTIVE_TRIP_EVENT_ID_QUERY_PARAM } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/constants';
import area from 'components/shared/GlobalModalArea/area';
import AlertModal from 'components/shared/GlobalModalArea/Modal/AlertModal';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

import { useLandingV2Context } from '../../../context';
import { useBlockContext } from '../Block/context';

export function useReadonlyBlockClick() {
  const history = useHistory();
  const { readonly } = useLandingV2Context();
  const { block } = useBlockContext();
  const { data } = useLandingV2Context();
  const getStepPath = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.ITINERARY);
  const handleAccept = useCallback(
    (res: () => void) => {
      const query = block.meta?.tripEventId ? `?${ACTIVE_TRIP_EVENT_ID_QUERY_PARAM}=${block.meta.tripEventId}` : '';
      history.push(getStepPath(ITINERARY_STEPS.DETAILS, data.id) + query);

      res();
    },
    [history, block, data.id, getStepPath],
  );

  return useCallback(() => {
    if (readonly) return;

    showModal(area, (res) => {
      return (
        <AlertModal
          headerText="Heads Up!"
          confirmButtonText="Yes, Go"
          closeButtonText="Cancel"
          res={res}
          onAccept={() => handleAccept(res)}
          bodyText="You can only edit events from the Details tab. Would you like to go there now?"
        />
      );
    });
  }, [handleAccept, readonly]);
}
